<ng-icon [svg]="svg()" [size]="size()" />
